import { MembershipForChangeDTO } from "@gymflow/types";
import { z } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";

import { ChangeMembershipFormValues } from "./types";

export const INITIAL_VALUES_CHANGE_MEMBERSHIP_FORM: ChangeMembershipFormValues =
  {
    newMembership: undefined,
    date: undefined,
  };

export const changeMembershipFormSchema = toFormikValidationSchema(
  z.object({
    newMembership: z
      .object(
        {
          id: z.union([z.string(), z.number()]),
          label: z.string(),
          subLabel: z.string().optional(),
          value: z.custom<MembershipForChangeDTO>(),
        },
        { required_error: "Select Membership is required" },
      )
      .nullable(),
    date: z
      .object(
        {
          id: z.union([z.string(), z.number()]),
          label: z.string(),
          value: z.custom<string>(),
        },
        { required_error: "Scheduled Date is required" },
      )
      .nullable(),
  }),
);
